export default __webpack_public_path__ + "static/media/aren.e4216360.svg";